import {ApplicationRef, Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TrnAdmissionService} from '../../configuration/trn-admission/trn-admission.service';
import {MipdDischargeTemplateService} from '../../configuration/mipd-discharge-template/mipd-discharge-template.service';
import {ToastsManager} from 'ng2-toastr';
import {DischargeSummaryNewService} from './discharge-summary-new.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DatepickerConfig} from '../../shared/custom-service/datepicker-configuration.service';
import {MstDischargeSummaryFormService} from '../../configuration/mst-discharge-summary-form/mst-discharge-summary-form.service';
import {MstFieldService} from '../../configuration/mst-field/mst-field.service';
import {MstSectionService} from '../../configuration/mst-section/mst-section.service';
import {MstTabService} from '../../configuration/mst-tab/mst-tab.service';
import {MstSetService} from '../../configuration/mst-set/mst-set.service';
import {TemrVisitHistoryService} from '../../configuration/temr-visit-history/temr-visit-history.service';
import {TemrVitalService} from '../../configuration/temr-vital/temr-vital.service';
import * as base_path from '../../shared/my-constants';
import {Shatabdi, Shatabdi2} from '../../shared/my-constants';
import {MpathResultService} from '../../configuration/mpath-result/mpath-result.service';
import {LabOrderListService} from '../../investigation/pathology/lab_order_list/lab_order_list.service';
import {LabReportsService} from '../../investigation/pathology/lab_report/lab_reports.service';
import {DischargeService} from '../discharge/discharge.service';
import {OpdPatientConfigService} from '../../configuration/application-configuration/opd-patient-config/opd-patient-config.service';
import {ConfirmationService} from 'primeng/primeng';
import {MstVisitService} from '../../configuration/mst-visit/mst-visit.service';
import {EmgPatientListService} from '../../emergency/emg-patient-list/emg-patient-list.service';
import {InvItemService} from '../../configuration/inv-item/inv-item.service';
import {TemrVisitDiagnosisService} from '../../configuration/temr-visit-diagnosis/temr-visit-diagnosis.service';
import {TemrTimelineService} from '../../configuration/temr-timeline/temr-timeline.service';
import {PaginationInstance} from 'ngx-pagination';
import {MemrDrugInstructionService} from '../../configuration/memr-drug-instruction/memr-drug-instruction.service';
import {MstRouteService} from '../../configuration/mst-route/mst-route.service';
import {TemrVisitPrescriptionService} from '../../configuration/temr-visit-prescription/temr-visit-prescription.service';
import {TemrVisitChiefComplaintService} from '../../configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.service';
import {TemrVisitNonDrugAllergyService} from '../../configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.service';
import {MstNonDrugAllergyService} from '../../configuration/mst-non-drug-allergy/mst-non-drug-allergy.service';
import {TemrVisitAllergyService} from '../../configuration/temr-visit-allergy/temr-visit-allergy.service';
import {MemrIcdCodeService} from '../../configuration/memr-icd-code/memr-icd-code.service';
import {CpoePrescriptionService} from '../../patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-prescription/cpoe-prescription.service';
import {MstDoseFrequencyService} from '../../configuration/mst-dose-frequency/mst-dose-frequency.service';
import {MstDischargeSpinstructionGroupService} from '../../configuration/mst-discharge-spinstruction-group/mst-discharge-spinstruction-group.service';
import {MstDischargeSpecialInstructionService} from '../../configuration/mst-discharge-special-instruction/mst-discharge-special-instruction.service';
import {ApiRequestService} from '../../shared/api-request-service';
import {DataService} from '../../patient-chart/data.service';

declare var $: any;

@Component({
    selector: 'app-discharge-summary-new',
    templateUrl: './discharge-summary-new.component.html',
    styleUrls: ['./discharge-summary-new.css']
})
export class DischargeSummaryNewComponent implements OnInit {
    mstDoseFrequencyList: Array<any> = [];
    currentPatient: any = {};
    currentUserdetails: any;
    visit_id: any = '';
    patientMrNumber: any;
    visitid: any;
    selectedNonDrugAllergied: any = {};
    nondrugAllergy: Array<any> = [];
    dischargeSpInstructionGroup: Array<any> = [];
    selectedalllist: Array<any> = [];
    diagnosisTextarea: Array<any> = [];
    AddForm: FormGroup;
    selectedadmissionid: any;
    patientList: Array<any> = [];
    templatelist: Array<any> = [];
    formlist: Array<any> = [];
    selectedFormSecList: Array<any> = [];
    selectedFormSecPrevList: Array<any> = [];
    selectedFormTabList: Array<any> = [];
    selectedFormTabPrevList: Array<any> = [];
    selectedFormSetList: Array<any> = [];
    selectedFormSetPrevList: Array<any> = [];
    selectedFormFieldList: Array<any> = [];
    selectedFormFieldPrevList: Array<any> = [];
    selectedFormFieldQAList: Array<any> = [];
    admissionFieldList: Array<any> = [];
    templateparameterlist: Array<any> = [];
    selectedparameterlist: Array<any> = [];
    addedFieldArr: any = [];
    selectedpatient: any;
    icdCodeList: any;
    datePickerConfig: any;
    timelineId: any;
    dateObject: any;
    selectedForm: any = {};
    time: any;
    dischargeSummPreview: Boolean = false;
    myDiagnosisModel: Boolean = false;
    shatabdi: boolean = Shatabdi;
    shatabdi2: boolean = Shatabdi2;
    startdate1: any;
    ckEditorContent: any = '';
    ckEditorResult: any = '';
    vitalHistory: Array<any> = [];
    timeline: Array<any> = [];
    doctorAdviceHistory: Array<any> = [];
    chiefComplaintHistory: Array<any> = [];
    diagnosidHistory: Array<any> = [];
    labReportHistory: Array<any> = [];
    tpathBsList: Array<any> = [];
    multiReport: Array<any> = [];
    listOfReports: Array<any> = [];
    reportsList: Array<any> = [];
    selectedReportResult: Array<any> = [];
    selectedDischargeSummary: Array<any> = [];
    selecteddischargepatient: any = {};
    dischargeformPrint = false;
    dischargedate: any;
    followupdate: any;
    unitinfo: any = {};
    userdetails: any = {};
    staffId: any;
    selectedValue: any;
    isFinalized: boolean = false;
    finalizedBy: any = 0;
    admission_mr_no: any;
    admissionId: any;
    usersign_url = base_path.usersign;
    saveLabel: Boolean = false;
    vistid: any;
    eplId: any;
    selectedPatient: any = {};
    dischaergeStaffName: any;
    trnDischarge: any;
    mstItemList: Array<any> = [];
    selectedItem: any = {};
    selectedDischargeSpInstructionGroup: any = {};
    selectedAutoCompleteItem: any = [];
    selectedAutoCompleteDischargeSpInstructionGroup: any = [];
    selectedItemList: Array<any> = [];
    selectedDischargeSpInstructionGroupList: Array<any> = [];
    prescriptionList: Array<any> = [];
    selectedAllergy: any = null;
    mstDrugAllergyList: Array<any> = [];
    mstIcdCodeListPopup: Array<any> = [];
    duraton: any;
    overAllQty: any = 0;
    totalQuantity = 0;
    public diagPopupconfig: PaginationInstance = {
        id: 'advanced2',
        itemsPerPage: 5,
        currentPage: 1,
        totalItems: 1
    };
    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 5,
        currentPage: 1,
        totalItems: 1
    };
    public diagDonfig: PaginationInstance = {
        id: 'advanced1',
        itemsPerPage: 5,
        currentPage: 1,
        totalItems: 1
    };
    isDignosisAdded: Boolean = false;
    timelineObj: any = {};
    loading: boolean;
    mstDrugInstructionList: Array<any> = [];
    mstRouteList: Array<any> = [];
    currentPrescription: Array<any> = [];
    editprescription: Boolean = false;
    forUpdate: any = 0;
    selecteddfName: any = {};
    selectedcheflist: Array<any> = [];
    currentVisit: any = {};
    visitObj: any = {};
    allergyList: Array<any> = [];
    temrVisitHistory: any = {};
    displayPrecp: Boolean = false;
    selectedICDCode: any;
    available: boolean;
    mstIcdCodeList: Array<any> = [];
    currentUser: any = {};
    currFreq: any;
    mstDischargeSpecialInstructionList: any = [];
    mstDischargeSpInstructionGroupList: Array<any> = [];
    mstDischargeSpecialInstructionviewtype: string = 'list';
    mstDischargeSpInstructionGroupviewtype: string = 'list';

    dischargeSpInstructionGroupIndex: any;
    displaydischargeSpInstructionGroupIndex: boolean = false;

    constructor(
        private temrVisitNonDrugAllergyService: TemrVisitNonDrugAllergyService,
        private mstNonDrugAllergyService: MstNonDrugAllergyService,
        private route: ActivatedRoute,
        private router: Router,
        private ref: ApplicationRef,
        vcr: ViewContainerRef,
        private fb: FormBuilder,
        public toastr: ToastsManager,
        private TrnAdmissionService: TrnAdmissionService,
        private MipdDischargeTemplateService: MipdDischargeTemplateService,
        private apiRequestService: ApiRequestService,
        private mstDischargeSummaryNewService: DischargeSummaryNewService,
        private mstDischargeSummaryFormService: MstDischargeSummaryFormService,
        private mstFieldService: MstFieldService,
        private mstSectionService: MstSectionService,
        private mstTabService: MstTabService,
        private temrVisitHistoryService: TemrVisitHistoryService,
        private temrVitalService: TemrVitalService,
        private mpathResultService: MpathResultService,
        private labOrderListService: LabOrderListService,
        private mstSetService: MstSetService,
        private labReportsService: LabReportsService,
        private dischargeService: DischargeService,
        private application: OpdPatientConfigService,
        private confirmationService: ConfirmationService,
        private emgPatientListService: EmgPatientListService,
        private mstVisitService: MstVisitService,
        private itemService: InvItemService,
        public temrVisitDiagnosisService: TemrVisitDiagnosisService,
        private temrTimelineService: TemrTimelineService,
        private memrDrugInstructionService: MemrDrugInstructionService,
        private mstRouteService: MstRouteService,
        private temrVisitPrescriptionService: TemrVisitPrescriptionService,
        private temrVisitChiefComplaintService: TemrVisitChiefComplaintService,
        private temrVisitAllergyService: TemrVisitAllergyService,
        private memrIcdCodeService: MemrIcdCodeService,
        private cpoePrescriptionService: CpoePrescriptionService,
        private mstDoseFrequencyService: MstDoseFrequencyService,
        private mstDischargeSpecialInstructionService: MstDischargeSpecialInstructionService,
        private mstDischargeSpInstructionGroupService: MstDischargeSpinstructionGroupService,

    ) {
        this.datePickerConfig = DatepickerConfig;
        this.toastr.setRootViewContainerRef(vcr);
        this.AddForm = fb.group({
            'dsnAdmissionId': fb.group({
                'admissionId': [null, Validators.required]
            }),

            'dsnVisitId': fb.group({
                'visitId': [null, Validators.required]
            }),
            'followupDate': [null],
            'followupDatePersion': [null],
            'isFinalized': [null]
        });

        this.AddForm = fb.group({
            'dsnAdmissionId': fb.group({
                'admissionId': [null, Validators.required]
            }),

            'dsnVisitId': fb.group({
                'visitId': [null, Validators.required]
            }),
            'followupDate': [null],
            'followupDatePersion': [null],
            'isFinalized': [null]
        });
        // this.ref.tick();
    }

    ngOnInit() {
        this.userdetails = JSON.parse(sessionStorage.getItem('userdetail'));
        this.currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
        this.staffId = this.userdetails.staffId;
        this.dateObject = '';
        this.time = new Date().getTime();
        // this.data.currentTimeline.subscribe(timelineObj => this.timelineObj = timelineObj);
        // this.MipdDischargeTemplateService.gettemplatelist().then(resp => this.templatelist = resp.record);
        this.mstDischargeSummaryFormService.getAllRecordService('', '', '', '', '').then(resp => {
            this.formlist = resp.content;
        });
        this.startdate1 = new Date().toISOString().substring(0, 10);
        this.application.getRecordByUnitId(sessionStorage.getItem('unitId')).then(resp => {
            this.unitinfo = resp.configUnitId;
        });
        this.route.params.subscribe((params: any) => {
            this.admissionId = params['admission_id'];
            // this.onLoadAdmissionId(this.admissionId);
            // console.log('admission_mr_no ', this.admissionId);
            if (this.admissionId != undefined) {
                this.TrnAdmissionService.getRecordService(this.admissionId).then(trnAdmission => {
                    this.onModifyDischargeSummary(trnAdmission);
                });
            }
        });
        // this.vistid = this.route.snapshot.paramMap.get('visit_id');
        this.route.params.subscribe((params: any) => {
            this.vistid = params['visit_id'];
            this.eplId = params['eplId'];
            console.log('visit_id ', this.vistid);
            if (this.vistid != undefined) {
                this.dischargeVisit();
                this.AddForm.controls.dsnVisitId.get('visitId').setValue(this.vistid);
                this.emgPatientListService.getEmgPatientObj(this.eplId).then(epl => {
                    this.dischargedate = epl.dischargedDate;
                    console.log('epl ', epl);
                });
            }
        });
        this.getDrugInstruction();
        // this.getDignosisList(1);
        // this.getSavedPrescription();
        console.log('visit_id ', this.vistid);
        console.log('visit_id1 ', this.timelineObj.timelineId);
    }

    dischargeVisit() {
        this.selectedFormTabList.length = 0;
        this.selectedFormSetList = [];
        this.selectedFormFieldList = [];
        this.selectedFormFieldQAList = [];
        this.selectedFormSecList = [


        ];
        this.vitalHistory = [];
        this.chiefComplaintHistory = [];
        this.doctorAdviceHistory = [];
        this.diagnosidHistory = [];
        this.selectedReportResult = [];
        this.tpathBsList = [];
        this.selectedparameterlist = [];
        this.mstVisitService.getrecordbyvisit(this.vistid).then(resp => {
            this.selectedpatient = resp.visitPatientId;
            this.AddForm.controls.dsnVisitId.get('visitId').setValue(this.vistid);
            this.mstDischargeSummaryNewService.getHistoryservicevisit(resp).then(history => {
                this.selectedValue = history.formId;
                if (this.selectedValue != undefined || this.selectedValue !== null) {
                    this.gettemplatebynameDefault(this.selectedValue);
                }
                this.vitalHistory.push(history.TemrVital);
                this.chiefComplaintHistory = history.TemrVisitChiefComplaint;
                this.timeline = history.TemrTimeline;
                if (this.timeline != undefined) {
                    for (let timeliene of this.timeline) {
                        if (timeliene.timelineIsDoctorsAdvice) {
                            let json = {
                                'timelineDoctorAdvice': timeliene.timelineDoctorAdvice,
                                'timelineDoctorAdviceCreatedStaffName': timeliene.timelineDoctorAdviceCreatedStaffName
                            };
                            this.doctorAdviceHistory.push(json);
                            console.log('this.doctorAdviceHistory :', this.doctorAdviceHistory);
                        }
                    }
                }
                this.diagnosidHistory = history.TemrVisitDiagnosis;
                this.tpathBsList = history.tpathbsListOPD;
                if (this.tpathBsList != undefined) {
                    for (let tPathBs of this.tpathBsList) {
                        this.labOrderListService.getReportedTestByPsId('', '', '', tPathBs.psId, '', '').subscribe(multiReport => {
                            this.multiReport = multiReport;
                            // console.log('this.multiReport :', this.multiReport);
                            let k = 0;
                            if (this.multiReport != undefined) {
                                if (this.multiReport.length > 0) {
                                    this.labOrderListService.getRecordByTrId('', '', '', this.multiReport[0].trId, 'Asc', 'trId').subscribe(selectedReportResult => {
                                        this.selectedReportResult.push(selectedReportResult);
                                    });
                                }
                            }
                        });
                    }
                }
            });
        });
    }

    // getdischargedescription(event: any, radio?: any) {
    //     console.log('event', event);
    //     // console.log('radio', radio);
    //     if (radio == 'Yes') {
    //         event.target.value = 'Yes';
    //     } else if (radio == 'No') {
    //         event.target.value = 'No';
    //     }

    //     this.selectedparameterlist = this.selectedparameterlist.filter(it => it.dsnFieldId.fieldId != Number(event.target.name));
    //     this.selectedparameterlist.push({dsnFieldId: {fieldId: event.target.name}, dsnFieldDesacription: event.target.value});
    //     this.mstFieldService.getRecordService(Number(event.target.name)).then(fieldObj => {
    //         // console.log('fieldName :  ', fieldObj.fieldName);
    //         // this.ckEditorContent = this.ckEditorContent + fieldObj.fieldName +': ' + event.target.value ;
    //     });
    //     // console.log('selectedparameterlist :  ', this.selectedparameterlist);
    // }

    getdischargedescription(event: any, radio?: any) {
        if (radio === 'Yes') {
            event.target.value = 'Yes';
        } else if (radio === 'No') {
            event.target.value = 'No';
        }
    
        const fieldId = Number(event.target.name);
        let value = event.target.value.trim();
    
        this.selectedparameterlist = this.selectedparameterlist.filter(
            it => it.dsnFieldId.fieldId !== fieldId
        );
    
    
        if (value && value.replace(/,/g, '') !== '') {
            this.selectedparameterlist.push({
                dsnFieldId: { fieldId: fieldId },
                dsnFieldDesacription: value
            });
        }
    
        this.mstFieldService.getRecordService(fieldId).then(fieldObj => {
            console.log('fieldName:', fieldObj.fieldName);
        });
    }
    
    getdischargedescriptionCkEditor(event: any, fieldId: any) {

        this.selectedparameterlist = this.selectedparameterlist.filter(it => it.dsnFieldId.fieldId != Number(fieldId));
        this.selectedparameterlist.push({dsnFieldId: {fieldId: fieldId}, dsnFieldDesacription: event});
        this.mstFieldService.getRecordService(Number(fieldId)).then(fieldObj => {
            // console.log('fieldName :  ', fieldObj.fieldName);
            // this.ckEditorContent = this.ckEditorContent + fieldObj.fieldName +': ' + event.target.value ;
        });
        // console.log('selectedparameterlist :  ', this.selectedparameterlist);
    }

    searchDropDown(url: any) {
        this.mstDischargeSummaryNewService.loadDropdown(url).then(resp => {
            this.icdCodeList = resp;
        });
    }

    onChangeIcdCodeandDesc3(event: any, index: any, selectedFormField: any) {
        console.log('selected icd', event);
        // this.selectedFormFieldList[index].fieldControlValue +=  '\n' + event.icCode + '  -  ' + event.icDescription;
        // console.log("Formcontrol value : "+ this.selectedFormFieldList[index].fieldControlValue);
        // this.selectedparameterlist = this.selectedparameterlist.filter(it => it.dsnFieldId.fieldId != Number(selectedFormField.fieldId));
        // let all_data = this.selectedFormFieldList[index].fieldControlValue;
        // this.selectedparameterlist.push({dsnFieldId: {fieldId: selectedFormField.fieldId}, dsnFieldDesacription: '\n'+all_data});
    }

    onChangeIcdCodeandDesc(event: any) {
        //  this.selectedPatient = this.autoCompletePatient;
        this.selectedICDCode = event;
        // console.log('selected icd code');
        // console.log(this.selectedICDCode);
        this.available = false;
        if (this.mstIcdCodeList != null) {
            // console.log('existing icd code');
            // console.log(this.mstIcdCodeList);
            for (let icd of this.mstIcdCodeList) {
                if (icd.icId == this.selectedICDCode.icId) {
                    this.available = true;
                }
            }
        }
        else {
            this.available = false;
        }
        if (this.available === true) {
            this.toastr.error('ICD Code Is Already Added! ');
            this.selectedICDCode = [];
        }
        else {
            const model: any = {};
            model.vdAdmissionId = {'admissionId': this.selectedadmissionid};
            model.vdIcId = {'icId': this.selectedICDCode.icId};
            model.vdStatus = 1;
            model.createdByUserId = this.currentUser.staffId;
            model.createdBy = this.currentUser.staffUserId.userFirstname + ' ' + this.currentUser.staffUserId.userLastname;
            // console.log('dignosis');
            // console.log(model);
            this.temrVisitDiagnosisService.addRecordService(model).then(resp => {
                if (resp.success === '1') {
                    this.isDignosisAdded = true;
                    this.selectedICDCode = [];
                    this.toastr.success(resp.msg, ' ICD Code Saved Succesfully  ! ');
                    // this.getDignosisList();
                    this.getDignosisListOnPopUp();
                }
                else {
                    this.toastr.error(resp.msg, 'Failed To Add ICD Code ! ');
                    this.selectedICDCode = [];
                }
            });
        }
    }

    searchDesc(event, colValue: any) {
        const qString: string = event.query;
        this.memrIcdCodeService.getDropDown(1, 10, event.query).then(resp => {
            // console.log(resp);
            this.icdCodeList = resp;
        });
    }

    onAdd(model: any) {
        let currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
        let myModel = {
            dssAdmissionId: { admissionId: this.selectedadmissionid },
            dssStaffId: { staffId: currentUser.staffId },
            dssStatus: 'Update',
        };
    
        this.apiRequestService.post('trn_discharge_summary_staff/create/', myModel).subscribe(resp => {
            console.log(resp);
        });
    
        console.log('On Add val', JSON.stringify(this.selectedparameterlist));
    
        // Filter selectedparameterlist to only include meaningful entries
        const filteredParams = this.selectedparameterlist.filter(p => p.dsnFieldDesacription && p.dsnFieldDesacription.replace(/,/g, '').trim() !== '');
    
        if (this.vistid == null) {
            for (let singlesummary of filteredParams) {
                let json = {
                    dsnId: '',
                    dsnAdmissionId: { admissionId: this.selectedadmissionid },
                    dsnFieldId: { fieldId: Number(singlesummary.dsnFieldId.fieldId) },
                    dsnFieldDesacription: singlesummary.dsnFieldDesacription,
                    dsnDsfId: { dsfId: this.selectedForm.dsfId },
                    followupDate: model.followupDate,
                    isFinalized: this.isFinalized,
                    createdby: this.currentUser.staffUserId.userFirstname + ' ' + this.currentUser.staffUserId.userLastname
                };
    
                if (this.finalizedBy !== 0) {
                    json['finalizedBy'] = { staffId: this.finalizedBy };
                }
    
                this.mstDischargeSummaryNewService
                    .getByAdmissionIdDsfIdFieldId(this.selectedadmissionid, this.selectedForm.dsfId, singlesummary.dsnFieldId.fieldId)
                    .then(mstDischargeSummResp => {
                        if (mstDischargeSummResp.content != null) {
                            json.dsnId = mstDischargeSummResp.content.dsnId;
                        }
    
                        this.mstDischargeSummaryNewService.addRecordService(json).then(resp => {
                            if (resp.success === '1') {
                                if (filteredParams[filteredParams.length - 1] === singlesummary) {
                                    this.toastr.success(resp.msg, 'Success!');
                                }
                            }
                        });
                    });
            }
            this.router.navigate(['/ipd/dischargelist']);
        } else {
            for (let singlesummary of filteredParams) {
                let json = {
                    dsnId: '',
                    dsnVisitId: { visitId: this.vistid },
                    dsnFieldId: { fieldId: Number(singlesummary.dsnFieldId.fieldId) },
                    dsnFieldDesacription: singlesummary.dsnFieldDesacription,
                    dsnDsfId: { dsfId: this.selectedForm.dsfId },
                    followupDate: model.followupDate,
                    isFinalized: this.isFinalized,
                    createdby: this.currentUser.staffUserId.userFirstname + ' ' + this.currentUser.staffUserId.userLastname
                };
    
                if (this.finalizedBy !== 0) {
                    json['finalizedBy'] = { staffId: this.finalizedBy };
                }
    
                this.mstDischargeSummaryNewService
                    .getByVisitIdDsfIdFieldId(this.vistid, this.selectedForm.dsfId, singlesummary.dsnFieldId.fieldId)
                    .then(mstDischargeSummResp => {
                        if (mstDischargeSummResp.content != null) {
                            json.dsnId = mstDischargeSummResp.content.dsnId;
                        }
    
                        this.mstDischargeSummaryNewService.addRecordEMGDischargeSummaryService(json).then(resp => {
                            if (resp.success === '1') {
                                if (filteredParams[filteredParams.length - 1] === singlesummary) {
                                    this.toastr.success(resp.msg, 'Success!');
                                }
                            }
                        });
                    });
            }
            this.router.navigate(['/emergency/emg-patient-discharge-list']);
        }
    }
    
    AddRecord(model: any) {
        let result;
        // console.log(this.selectedadmissionid);
        // console.log(this.selectedparameterlist);
        for (let singlesummary of this.selectedparameterlist) {
            model.dsAdmissionID.admissionId = this.selectedadmissionid;
            model.dsFieldName = singlesummary.dsFieldName;
            model.dsFieldDesacription = singlesummary.dsFieldDesacription;
            model.dsFieldDesacription = singlesummary.dsFieldDesacription;
            this.TrnAdmissionService.addRecordService(model).then(resp => {
                result = resp;
            });
        }
        return result;
    }

    showDate() {
        this.AddForm.controls.followupDate.setValue(this.dateObject);
        this.AddForm.controls.followupDatePersion.setValue(this.dateObject);
    }

    gettemplatebyname(formId: any) {
        this.selectedFormSecList = [];
        this.mstDischargeSummaryFormService.getRecordService(formId).then(formObj => {
            console.log('formObj', formObj);
            this.selectedForm = formObj;
            this.mstSectionService.getRecordServiceByDsfId(this.selectedForm.dsfId).then(sectionList => {
                console.log('sectionList', sectionList);
                this.selectedFormSecList = sectionList;
            });
        });
    }

    gettemplatebynameDefault(formId: any) {
        this.selectedFormSecList = [];
        this.mstDischargeSummaryFormService.getRecordService(formId).then(formObj => {
            this.selectedForm = formObj;
            this.mstSectionService.getRecordServiceByDsfId(this.selectedForm.dsfId).then(sectionList => {
                this.selectedFormSecList = sectionList;
                if (this.selectedFormSecList.length > 0) {
                    for (let i = 0; i < 1; i++) {
                        this.onSectionSelcted(sectionList[i].sectionId);
                    }
                }
            });
        });
    }

    onChangeMrNo(event: any) {
        this.selectedFormTabList.length = 0;
        this.selectedFormSetList = [];
        this.selectedFormFieldList = [];
        this.selectedFormFieldQAList = [];
        this.selectedFormSecList = [];
        this.vitalHistory = [];
        this.chiefComplaintHistory = [];
        this.doctorAdviceHistory = [];
        this.diagnosidHistory = [];
        this.selectedReportResult = [];
        this.tpathBsList = [];
        this.selectedPatient = event;
        //this.dischaergeStaffName = this.selectedPatient.dsnAdmissionId.admissionPatientId;
        //console.log(this.dischaergeStaffName);
        console.log('sel mr ', this.selectedPatient);
        this.getdischarge(this.selectedPatient.admissionId);
        this.mstDischargeSummaryNewService.getHistoryservice(event).then(resp => {
            console.log('event : ', (resp));
            this.selectedValue = resp.admissionId;
            this.vitalHistory = resp.TemrVital;
            this.chiefComplaintHistory = resp.TemrVisitChiefComplaint;
            this.doctorAdviceHistory = resp.TemrTimeline;
            this.diagnosidHistory = resp.TemrVisitDiagnosis;
            this.tpathBsList = resp.tpathbsListOPD;
            for (let tPathBs of this.tpathBsList) {
                this.labOrderListService.getReportedTestByPsId('', '', '', tPathBs.psId, '', '').subscribe(multiReport => {
                    this.multiReport = multiReport;
                    // console.log('this.multiReport :', this.multiReport);
                    let k = 0;
                    if (this.multiReport.length > 0) {
                        this.labOrderListService.getRecordByTrId('', '', '', this.multiReport[0].trId, 'Asc', 'trId').subscribe(selectedReportResult => {
                            this.selectedReportResult.push(selectedReportResult);
                        });
                    }
                });
            }
            this.mstDischargeSummaryNewService.getrecordservice(event.admissionId).then(mstDischargesummaryNewList => {
                if (mstDischargesummaryNewList.length > 0) {
                    this.saveLabel = true;
                    console.log("discharge list with mr no visit id", mstDischargesummaryNewList);
                    if (mstDischargesummaryNewList[0].isFinalized == 0) {
                        this.selectedpatient = event;
                        this.selectedadmissionid = event.admissionId;
                        // this.selectedvisitid = event.admissionId;
                        this.selectedadmissionid = event.admissionId;

                        this.AddForm.controls.dsnAdmissionId.get('admissionId').setValue(event.admissionId);
                        if (mstDischargesummaryNewList != undefined || mstDischargesummaryNewList !== null) {
                            this.gettemplatebynameDefault(this.selectedValue);
                        }
                    } else {
                        this.toastr.warning('Discharge Summary Is Already Finalized!!!');
                    }
                } else {
                    this.saveLabel = false;
                    this.selectedpatient = event;
                    this.selectedadmissionid = event.admissionId;
                    this.AddForm.controls.dsnAdmissionId.get('admissionId').setValue(event.admissionId);
                }
            });
        });
    }

    getdischarge(admission: any) {
        console.log(admission);
        this.selecteddischargepatient = admission;
        this.dischargeService.getRecordServicebyadmissionid(admission).then(resp => {
            console.log('response detected here');
            console.log(resp);
            this.trnDischarge = resp;
            // this.dischargeformdate = resp;
        });
        // this.dischargeform = true;
    }

    onModifyDischargeSummary(event: any) {
        this.selectedFormTabList.length = 0;
        this.selectedFormSetList = [];
        this.selectedFormFieldList = [];
        this.selectedFormFieldQAList = [];
        this.selectedFormSecList = [];
        this.vitalHistory = [];
        this.chiefComplaintHistory = [];
        this.doctorAdviceHistory = [];
        this.diagnosidHistory = [];
        this.selectedReportResult = [];
        this.tpathBsList = [];
        console.log('modify : ', event);
        this.mstDischargeSummaryNewService.getrecordservice(event.admissionId).then(mstDischargesummaryNewList => {
            this.saveLabel = true;
            this.selectedpatient = event;
            this.selectedadmissionid = event.admissionId;
            this.AddForm.controls.dsnAdmissionId.get('admissionId').setValue(event.admissionId);
            this.mstDischargeSummaryNewService.getHistoryservice(this.selectedpatient).then(resp => {
                console.log('event : ' + JSON.stringify(resp));
                this.selectedValue = resp.admissionId;
                if (this.selectedValue != undefined || this.selectedValue !== null) {
                    this.gettemplatebynameDefault(this.selectedValue);
                }
                this.vitalHistory = resp.TemrVital;
                this.chiefComplaintHistory = resp.TemrVisitChiefComplaint;
                this.doctorAdviceHistory = resp.TemrTimeline;
                this.diagnosidHistory = resp.TemrVisitDiagnosis;
                this.tpathBsList = resp.tpathbsListOPD;
                for (let tPathBs of this.tpathBsList) {
                    this.labOrderListService.getReportedTestByPsId('', '', '', tPathBs.psId, '', '').subscribe(multiReport => {
                        this.multiReport = multiReport;
                        // console.log('this.multiReport :', this.multiReport);
                        let k = 0;
                        if (this.multiReport.length > 0) {
                            this.labOrderListService.getRecordByTrId('', '', '', this.multiReport[0].trId, 'Asc', 'trId').subscribe(selectedReportResult => {
                                this.selectedReportResult.push(selectedReportResult);
                            });
                        }
                    });
                }
            });
        });
    }

    onLoadAdmissionId(admissionId: any) {
        this.selectedFormTabList.length = 0;
        this.selectedFormSetList = [];
        this.selectedFormFieldList = [];
        this.selectedFormFieldQAList = [];
        this.selectedFormSecList = [];
        this.vitalHistory = [];
        this.chiefComplaintHistory = [];
        this.doctorAdviceHistory = [];
        this.diagnosidHistory = [];
        this.selectedReportResult = [];
        this.tpathBsList = [];
        this.selectedpatient = {};
        this.selectedpatient['admissionId'] = admissionId;
        this.mstDischargeSummaryNewService.getHistoryservice(this.selectedpatient).then(resp => {
            console.log('event : ' + JSON.stringify(resp));
            this.selectedValue = resp.admissionId;
            if (this.selectedValue != undefined || this.selectedValue !== null) {
                this.gettemplatebynameDefault(this.selectedValue);
            }
            this.vitalHistory = resp.TemrVital;
            this.chiefComplaintHistory = resp.TemrVisitChiefComplaint;
            this.doctorAdviceHistory = resp.TemrTimeline;
            this.diagnosidHistory = resp.TemrVisitDiagnosis;
            this.tpathBsList = resp.tpathbsListOPD;
            for (let tPathBs of this.tpathBsList) {
                this.labOrderListService.getReportedTestByPsId('', '', '', tPathBs.psId, '', '').subscribe(multiReport => {
                    this.multiReport = multiReport;
                    // console.log('this.multiReport :', this.multiReport);
                    let k = 0;
                    if (this.multiReport.length > 0) {
                        this.labOrderListService.getRecordByTrId('', '', '', this.multiReport[0].trId, 'Asc', 'trId').subscribe(selectedReportResult => {
                            this.selectedReportResult.push(selectedReportResult);
                        });
                    }
                });
            }
        });
    }

    searchPatientByMrno(event) {
        let qString: string = event.query;
        this.TrnAdmissionService.getmrnoautocomplite(qString).then(
            resp => {
                // // console.log(resp);
                this.patientList = resp.record;
            });
    }

    onSectionSelcted(sectionId) {
        this.selectedFormTabList.length = 0;
        this.selectedFormSetList = [];
        this.selectedFormFieldList = [];
        this.selectedFormFieldQAList = [];
        this.selectedparameterlist = [];
        let count: Boolean = false;
        // console.log('Lists : ', this.selectedFormTabList, this.selectedFormSetList, this.selectedFormFieldList, this.selectedFormFieldQAList);
        this.mstTabService.getTabListByDsfIdSectionId(this.selectedForm.dsfId, sectionId).then(tabList => {
            this.selectedFormTabList = tabList;
            for (let tab of this.selectedFormTabList) {
                // console.log('Tab', tab);
                this.mstSetService.getsetListByDsfIdSectionIdTabId(this.selectedForm.dsfId, sectionId, tab.tabId).then(setList => {
                    for (let set of setList) {
                        this.selectedFormSetList = this.selectedFormSetList.filter(it => it.setId != set.setId);
                        this.selectedFormSetList.push(set);
                        console.log('formfield list :', this.selectedFormSetList);
                    }
                    for (let set of this.selectedFormSetList) {
                        this.mstFieldService.getFieldListByDsfIdSectionIdTabIdSetId(this.selectedForm.dsfId, sectionId, tab.tabId, set.setId).then(fieldList => {
                            for (let field of fieldList) {
                                // console.log('field', field);
                                if (this.vistid == undefined) {
                                    this.mstDischargeSummaryNewService.getrecordservice(this.selectedadmissionid).then(mstDischargesummaryNewList => {
                                        this.admissionFieldList = mstDischargesummaryNewList;
                                        if (count === false) {
                                            // console.log('mstDischargesummaryNewList', mstDischargesummaryNewList[0]);
                                            if (mstDischargesummaryNewList.length > 0) {
                                                if (mstDischargesummaryNewList[0].isFinalized === true) {
                                                    this.isFinalized = true;
                                                    this.finalizedBy = this.staffId;
                                                    this.AddForm.get('isFinalized').setValue(true);
                                                    this.AddForm.controls.followupDate.setValue(mstDischargesummaryNewList[0].followupDate);
                                                }
                                                count = true;
                                            }
                                        }
                                        for (let mstDischargesummaryNew of mstDischargesummaryNewList) {
                                            if (mstDischargesummaryNew.dsnFieldId.fieldId == field.fieldId) {
                                                if (mstDischargesummaryNew.dsnFieldId.fieldControlName == 'radio' && mstDischargesummaryNew.dsnFieldId.fieldControlValue == 'Yes') {
                                                }
                                                field.fieldControlValue = mstDischargesummaryNew.dsnFieldDesacription;
                                                //this.selectedparameterlist.push({dsnFieldId: {fieldId: field.fieldId}, dsnFieldDesacription: field.fieldControlValue});
                                            }
                                        }
                                    });
                                } else {
                                    this.mstDischargeSummaryNewService.getrecordservicevisit(this.vistid).then(mstDsnByVisitId => {
                                        console.log('mstDsnByVisitId', mstDsnByVisitId);
                                        for (let mstDischargesummaryNew of mstDsnByVisitId) {
                                            this.saveLabel = true;
                                            if (mstDischargesummaryNew.dsnFieldId.fieldId == field.fieldId) {
                                                if (mstDischargesummaryNew.dsnFieldId.fieldControlName == 'radio' && mstDischargesummaryNew.dsnFieldId.fieldControlValue == 'Yes') {
                                                }
                                                field.fieldControlValue = mstDischargesummaryNew.dsnFieldDesacription;
                                                //this.selectedparameterlist.push({dsnFieldId: {fieldId: field.fieldId}, dsnFieldDesacription: field.fieldControlValue});
                                            }
                                        }
                                    });
                                }

                                //set form default values
                                this.selectedparameterlist.push({dsnFieldId: {fieldId: field.fieldId}, dsnFieldDesacription: field.fieldControlValue});

                                this.selectedFormFieldList = this.selectedFormFieldList.filter(it => it.fieldId != field.fieldId);
                                this.selectedFormFieldList.push(field);
                                console.log('Selected form field : ', this.selectedFormFieldList);

                                this.mstFieldService.getQAListRecordService(field.fieldId).then(QAList => {
                                    if (QAList.length > 0) {
                                        for (let questionAns of QAList) {
                                            this.selectedFormFieldQAList.push(questionAns);
                                        }
                                    }
                                    // console.log('QAList', this.selectedFormFieldQAList);
                                });
                            }
                        });
                    }
                });
            }
        });
    }

    onPreviewDischargeSummary() {
        console.log('content : ' + this.getValueWithAsync());
        // // console.log('selectedparameterlist', this.selectedparameterlist);
        this.dischargeSummPreview = true;
    }

    getValueWithAsync() {
        let resultString: any = '';
        let data = [];
        for (let selectedparameter of this.selectedparameterlist) {
            let model = {'key': Number(selectedparameter.dsnFieldId.fieldId), 'desc': selectedparameter.dsnFieldDesacription};
            data.push(model);
        }
        this.mstFieldService.getConcatenate(data).then(fieldObj => {
            this.ckEditorResult = fieldObj.result;
        });
        return resultString;
    }

    printdischargeform(printContentssummary: any): void {
        var mywindow = window.open('', 'my div', 'height=400,width=600');
        mywindow.document.write('<html><head><title>my div</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write(this.ckEditorResult);
        mywindow.document.write('</body></html>');
        mywindow.print();
        mywindow.close();
    }

    getdischargesummarynew() {
        if (this.vistid === undefined) {
            this.dischargeService.getRecordServicebyadmissionid(this.selectedadmissionid).then(resp => {
                this.dischargedate = resp.dischargeDate;
                this.selecteddischargepatient = resp.dischargeAdmissionId;
                this.dischaergeStaffName = resp.dischargeStaffId.staffUserId.userFullname;
            });
    
            this.mstDischargeSummaryNewService.getrecordservice(this.selectedadmissionid).then(mstDischargesummaryNew => {
                this.admissionFieldList = mstDischargesummaryNew;
    
                if (mstDischargesummaryNew && mstDischargesummaryNew.length > 0) {
                    this.followupdate = this.admissionFieldList[0].followupDate;
    
                    this.mstDischargeSummaryFormService.getRecordService(mstDischargesummaryNew[0].dsnDsfId.dsfId).then(formObj => {
                        this.mstSectionService.getRecordServiceByDsfId(formObj.dsfId).then(sectionList => {
                            this.selectedFormSecPrevList = sectionList;
    
                            let tabPromises = [];
    
                            for (let section of sectionList) {
                                tabPromises.push(
                                    this.mstTabService.getTabListByDsfIdSectionId(formObj.dsfId, section.sectionId).then(tabList => {
                                        for (let tab of tabList) {
                                            this.selectedFormTabPrevList = this.selectedFormTabPrevList.filter(it => it.tabId !== tab.tabId);
                                            this.selectedFormTabPrevList.push(tab);
    
                                            this.mstSetService.getsetListByDsfIdSectionIdTabId(
                                                this.admissionFieldList[0].dsnDsfId.dsfId,
                                                section.sectionId,
                                                tab.tabId
                                            ).then(setList => {
                                                for (let set of setList) {
                                                    this.selectedFormSetPrevList.push(set);
                                                }
                                            });
                                        }
                                    })
                                );
                            }
    
                            // Wait until all tabs are loaded before opening dialog
                            Promise.all(tabPromises).then(() => {
                                setTimeout(() => {
                                    this.dischargeformPrint = true;
                                }, 50);
                            });
                        });
                    });
                } else {
                    this.toastr.warning('Please Fill And Save Discharge Summary');
                }
            });
    
        } else {
            this.mstDischargeSummaryNewService.getrecordservicevisit(this.vistid).then(mstDischargesummaryNew => {
                this.admissionFieldList = mstDischargesummaryNew;
    
                if (mstDischargesummaryNew && mstDischargesummaryNew.length > 0) {
                    this.followupdate = this.admissionFieldList[0].followupDate;
    
                    this.mstDischargeSummaryFormService.getRecordService(mstDischargesummaryNew[0].dsnDsfId.dsfId).then(formObj => {
                        this.mstSectionService.getRecordServiceByDsfId(formObj.dsfId).then(sectionList => {
                            this.selectedFormSecPrevList = sectionList;
    
                            let tabPromises = [];
    
                            for (let section of sectionList) {
                                tabPromises.push(
                                    this.mstTabService.getTabListByDsfIdSectionId(formObj.dsfId, section.sectionId).then(tabList => {
                                        for (let tab of tabList) {
                                            this.selectedFormTabPrevList = this.selectedFormTabPrevList.filter(it => it.tabId !== tab.tabId);
                                            this.selectedFormTabPrevList.push(tab);
    
                                            this.mstSetService.getsetListByDsfIdSectionIdTabId(
                                                this.admissionFieldList[0].dsnDsfId.dsfId,
                                                section.sectionId,
                                                tab.tabId
                                            ).then(setList => {
                                                for (let set of setList) {
                                                    this.selectedFormSetPrevList.push(set);
                                                }
                                            });
                                        }
                                    })
                                );
                            }
    
                            Promise.all(tabPromises).then(() => {
                                setTimeout(() => {
                                    this.dischargeformPrint = true;
                                }, 50);
                            });
                        });
                    });
                } else {
                    this.toastr.warning('Please Fill And Save Discharge Summary');
                }
            });
        }
    }
    
    confirmDialofFinalize() {
        this.isFinalized = true;
        this.finalizedBy = this.staffId;
        this.AddForm.get('isFinalized').setValue(true);
        this.onAdd(this.AddForm.value);
        this.toastr.success('Discharge Summary has been finalized successful', 'Success ! ');
        // this.confirmationService.confirm({
        //     message: 'Do you want to delete this service ?',
        //     header: 'Confirmation',
        //     icon: 'fa fa-question-circle',
        //     accept: () => {
        //
        //
        //     },
        //     reject: () => {
        //     }
        // });
    }

    /*    onFinalizeDischargeSummary(id: any) {
            this.mbillServiceService.deleteRecordService(id).then(resp => {
                if (resp.success === '1') {
                    this.toastr.success(resp.msg, 'Success ! ');
                    this.ngOnInit();
                }
                else {
                    this.toastr.error(resp.msg, 'Failed ! ');
                }
            });
        }
   */
    printdischargeNew(printContentssummary: any): void {
        let currentUser = JSON.parse(sessionStorage.getItem('userdetail'));
        let myModel = {
            'dssAdmissionId': {'admissionId': this.selectedadmissionid},
            'dssStaffId': {'staffId': currentUser.staffId},
            'dssStatus': 'Preview Print',
        };
        this.apiRequestService.post('trn_discharge_summary_staff/create/', myModel).subscribe(resp => {
            console.log(resp);
        });
        if ($('body').hasClass('smart-rtl')) {
            let printContentssummary, popupWin;
            printContentssummary = document.getElementById('printContentssummaryNew').innerHTML;
            //printContents = document.getElementById(printSection).innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write(`
          <html>
              <head>
                  <title>Print tab</title>
                  <style>
                    body{
                    direction: rtl;
                    }
                    .no-border>tbody>tr>td{
                      border: none !important;
                    }
                    .printNone{
                      display: none !important;
                    }
                    /*.ui-grid-col-6{*/
                     /*display: none !important;*/
                    /*}*/

                  </style>

                  <link rel="stylesheet" href="assets/css/your_style.css">

                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

              </head>
              <body onload="window.print();window.close()">${printContentssummary}
              </body>
          </html>`
            );
            popupWin.document.close();
        } else {
            let printContents, popupWin;
            printContents = document.getElementById('printContentssummaryNew').innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
            popupWin.document.open();
            popupWin.document.write(`
          <html>
              <head>
                  <title>Print tab1</title>
                  <style>
                    .no-border>tbody>tr>td{
                      border: none !important;
                    }
                    .printNone{
                      display: none !important;
                    }
                     /*.ui-grid-col-6{*/
                     /*display: none !important;*/
                    /*}*/
                    
                  </style>

                  <link rel="stylesheet" href="assets/css/your_style.css">

                  <!-- Latest compiled and minified CSS -->
                  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">

                  <!-- jQuery library -->
                  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>

                  <!-- Latest compiled JavaScript -->
                  <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>

              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
            );
            popupWin.document.close();
        }
    }

    searchItemByName(event: any) {
        // this.mstItemList = [];
        const qString: string = event.query;
        this.itemService.getTablesinCPOE(qString).then(resp => {
            this.mstItemList = resp;
            // console.log(this.mstItemList);
        });
    }

    // searchDischargeSpInstructionGroupByName(event: any) {
    //     // this.mstItemList = [];
    //     const qString: string = event.query;
    //     this.mstDischargeSpInstructionGroupService.getTablesinCPOE(qString).then(resp => {
    //         this.mstDischargeSpInstructionGroupList = resp;
    //         // console.log(this.mstItemList);
    //     });
    // }

    onChangeItemName(event: any) {
        console.log(event);
        this.selectedAutoCompleteItem = event;
        this.selectedItem = event;
        var count = 0;
        for (let selected_Item of this.selectedItemList) {
            //if item is already exists
            if (selected_Item.itemId == this.selectedItemList) {
                count++;
            }
        }
        //if item is new
        var isallery: Boolean = false;
        if (Number(count) == 0) {
            for (let allergy of this.mstDrugAllergyList) {
                console.log(allergy);
                for (let compound of this.selectedItem.icComponentId) {
                    if (allergy.vaCompoundId.compoundId == compound.compoundId) {
                        isallery = true;
                        this.selectedAllergy = allergy;
                        this.toastr.error(' This Patient Is Allergic To Content Which Are Used In This Drug , Do Not Prescribe', 'Warning');
                    }
                }
            }
            let obj: any = {};
            obj.ipInvItemId = this.selectedItem;
            if (this.selectedItem.itemRouteId != null) {
                obj.ipRouteId = {routeId: this.selectedItem.itemRouteId.routeId};
            }
            else {
                obj.ipRouteId = {routeId: ''};
            }
            obj.itemName = this.selectedAutoCompleteItem.itemName;
            obj.ipDfId = {dfId: ''};
            obj.ipDdId = '';
            obj.ipDiId = {diId: ''};
            obj.ipQuantity = '';
            obj.ipinstruction = '';
            obj.ipIsAllergic = isallery;
            obj.ipVaId = this.selectedAllergy;
            obj.dfName = '';
            this.selectedItemList.push(this.selectedItem);
            this.prescriptionList.push(obj);
            this.selectedAutoCompleteItem = [];
            this.selectedAllergy = null;
            isallery = false;
            console.log(this.prescriptionList);
        } else {
            this.toastr.error('Drug Already added ....', 'Warning');
            this.selectedAutoCompleteItem = [];
        }
    }

    onChangeDischargeSpInstructionGroupName(event: any) {
        console.log('selected event ', event);
        this.selectedAutoCompleteDischargeSpInstructionGroup = event;
        let groupInfo = {groupName: '', groupInstructions: []};
        this.mstDischargeSpecialInstructionService.getListbydischargespinstructiongroup(event.dsgId).then(resp => {
            groupInfo.groupName = resp[0].dsiDsgId.dsgName;
            for (let instruction of resp) {
                groupInfo.groupInstructions.push(instruction);
            }
            this.mstDischargeSpecialInstructionList.push(groupInfo);
            console.log(this.mstDischargeSpecialInstructionList);
        });
    }

    searchDischargeSpInstructionGroupName() {
        console.log(event);
        this.mstDischargeSpInstructionGroupService.getAllRecordService('1', '', '', '', '').then(
            resp => this.mstDischargeSpInstructionGroupList = resp.content
        );
    }

    setDischargeSpecialInstructionList() {
        let dischargeSpecialInstructionContent = document.getElementById('dischargeSpecialInstructionContent');
        // this.selectedFormFieldList[this.dischargeSpInstructionGroupIndex].fieldControlValue = '';
        this.selectedFormFieldList[this.dischargeSpInstructionGroupIndex].fieldControlValue += dischargeSpecialInstructionContent.innerHTML;

        console.log('selectedFormFieldList 1 : ', this.selectedFormFieldList);
    }

    // setmstDrugInstructionList() {
    //     // let dischargeSpecialInstructionContent = document.getElementById('dischargeSpecialInstructionContent');
    //     // // this.selectedFormFieldList[this.dischargeSpInstructionGroupIndex].fieldControlValue = '';
    //     // this.selectedFormFieldList[this.dischargeSpInstructionGroupIndex].fieldControlValue += dischargeSpecialInstructionContent.innerHTML;
    //
    //     console.log('selectedFormFieldList 1 : ', this.selectedFormFieldList);
    //     let prescriptionContent = document.getElementById('prescriptionTable');
    //     this.selectedFormFieldList[this.prescriptionIndex].fieldControlValue += prescriptionContent.innerHTML;
    //     this.timelineObj.timelineIsPrescription = true;
    //     console.log('selectedFormFieldList 1 : ', this.selectedFormFieldList);
    // }


    onAddPrescriptionText() {
        console.log(this.selectedAutoCompleteItem);
        if (this.selectedAutoCompleteItem != '') {
            this.selectedItem = event;
            var isallery: Boolean = false;
            let obj: any = {};
            // obj.itemFlag = true;
            obj.itemName = this.selectedAutoCompleteItem;
            // obj.ipInvItemId = {};
            // obj.ipInvItemId.itemName = this.selectedAutoCompleteItem;
            // obj.itemGenericId = {};
            // obj.itemGenericId.genericName = this.selectedAutoCompleteItem;
            if (this.selectedItem.itemRouteId != null) {
                obj.ipRouteId = {routeId: this.selectedItem.itemRouteId.routeId};
            }
            else {
                obj.ipRouteId = {routeId: ''};
            }
            obj.ipDfId = {dfId: ''};
            obj.ipDdId = '';
            obj.ipDiId = {diId: ''};
            obj.ipQuantity = '';
            obj.ipinstruction = '';
            obj.ipIsAllergic = isallery;
            obj.ipVaId = this.selectedAllergy;
            obj.dfName = '';
            this.selectedItemList.push(this.selectedItem);
            this.prescriptionList.push(obj);
            this.selectedAutoCompleteItem = [];
            this.selectedAllergy = null;
            isallery = false;
        } else {
            this.toastr.error('Select drug Name..!');
        }
    }

    getDignosisListOnPopUp(i?) {
        if (i != undefined) {
            this.diagnosisIndex = i;
        }
        let page = 1;
        this.myDiagnosisModel = true;
        console.log('event ', page);
        this.temrVisitDiagnosisService.getAllRecordServicebyAdmissionId(page, this.diagPopupconfig.itemsPerPage, this.selectedadmissionid, '', '')
            .then(resp2 => {
                console.log('Added Diagnosis for Admission', resp2[0]);
                this.diagPopupconfig.currentPage = page;
                // this.diagPopupconfig.totalItems = resp2.totalElements;
                this.loading = false;
                console.log('this.diagPopupconfig.totalItems ', this.diagPopupconfig.totalItems);
                //  this.temrVitalList = resp.content;
                this.mstIcdCodeListPopup = resp2;
                console.log('mstIcdCodeListPopup : ', this.mstIcdCodeListPopup);
                this.mstIcdCodeList = resp2;
                console.log('mstIcdCodeList : ', this.mstIcdCodeList);
            });
        this.getDrugInstruction();
    }

    getDrugInstruction() {
        this.memrDrugInstructionService.getAllRecordService(1, '', '', '', '')
            .then(resp => {
                this.mstDrugInstructionList = resp.content;
                console.log('List', resp.content);
                console.log('Drug List :', this.mstDrugInstructionList);
                this.getRouteList();
            });
    }

    getRouteList() {
        this.mstRouteService.getAllRecordService(1, '', '', '', '')
            .then(resp => {
                this.mstRouteList = resp.content;
                this.getSavedPrescription();
            });
    }

    getSavedPrescription() {
        this.selectedItemList = [];
        this.prescriptionList = [];
        this.temrVisitPrescriptionService.getPrescriptionByAdmissionIdNew(this.selectedadmissionid)
            .then(resp => {
                this.currentPrescription = resp;
                console.log('currentPrescription' , this.currentPrescription);
                if (this.currentPrescription.length > 0) {
                    this.editprescription = true;
                }
                for (let obj of resp) {
                    // this.forUpdate = obj.ipVpId.vpId;
                    this.updatePrescription(obj);
                }
            });
    }

    onAddForm(status: boolean) {
        let prescriptionContent = document.getElementById('prescriptionTable');
        this.selectedFormFieldList[this.prescriptionIndex].fieldControlValue += prescriptionContent.innerHTML;
        this.timelineObj.timelineIsPrescription = true;
        var count = 0;
        console.log(this.prescriptionList);
        this.prescriptionList.forEach(eachObj => {
            if (eachObj.ipQuantity === '' || eachObj.ipQuantity === null) {
                count++;
            }
        });
        console.log(this.selectedpatient);
        if (count == 0) {
            let model: any = {};
            model.vpPatientMrNumber = this.selectedpatient.admissionPatientId.patientMrNo;
            // model.vpAdmissionId = {admissionId: this.admissionId};
            model.vpAdmissionId = {admissionId: this.selectedadmissionid};
            // model.vpTimelineId = {timelineId: this.timelineObj.timelineId};
            // model.vpVisitId = {visitId: this.visit_id};

            model.vpPrescribedStaffId = {staffId: this.currentUser.staffId};
            model.vpStatus;

            this.cpoePrescriptionService.addRecordService(model)
                .then(resp => {

                    if (resp.success === '1') {
                        let id = resp.vpId;
                        let ObjArray: Array<any> = [];
                        for (let ob of this.prescriptionList) {
                            ob['itemFlag'] = true;
                            ob.ipVpId = {};
                            ob.ipVpId.vpId = id;
                            ob.createdByUserId = this.currentUser.staffId;
                            ob.createdBy = this.currentUser.staffUserId.userTitleId.titleName + ' ' + this.currentUser.staffUserId.userFirstname + ' ' + this.currentUser.staffUserId.userLastname;
                            if (ob.ipDfId.dfId == null || ob.ipDfId.dfId == '') {
                                delete ob.ipDfId;
                            }
                            if (ob.ipDiId.diId == null || ob.ipDiId.diId == '') {
                                delete ob.ipDiId;
                            }
                            if (ob.ipRouteId.routeId == null || ob.ipRouteId.routeId == '') {
                                delete ob.ipRouteId;
                            }
                            if (ob.ipInvItemId == undefined || ob.ipInvItemId.itemName == undefined || ob.ipInvItemId.itemName == null || ob.ipInvItemId.itemName == '') {
                                delete ob.ipInvItemId;
                            }
                            if (ob.itemGenericId == undefined || ob.itemGenericId.genericName == undefined || ob.itemGenericId.genericName == null || ob.itemGenericId.genericName == '') {
                                delete ob.itemGenericId;
                            }
                            console.log(ob);
                            delete ob.dfName;
                            ObjArray.push(ob);
                        }
                        this.temrVisitPrescriptionService.addDrugeList(ObjArray).then(resp2 => {
                            if (resp2.success === '1') {
                                this.timelineObj.timelineIsPrescription = true;
                                this.displayPrecp = false;
                                this.toastr.success(resp2.msg, 'Prescription Saved Succesfully !');
                                this.selectedAutoCompleteItem = [];
                                this.getSavedPrescription();
                            }
                        })
                        ;
                    }
                });
        }
        else {
            this.toastr.error('Please enter quantity or route', 'Incomplete Data! ');
            this.timelineObj.timelineIsPrescription = false;
        }
    }

    // onAddForms(status: boolean) {
    //     let prescriptionContent = document.getElementById('DischargeSpInstructionGroupTable');
    //     this.selectedFormFieldList[this.prescriptionIndex].fieldControlValue = prescriptionContent.innerHTML;
    //     this.timelineObj.timelineIsPrescription = true;
    //     var count = 0;
    //     console.log(this.prescriptionList);
    //     this.prescriptionList.forEach(eachObj => {
    //         if (eachObj.ipQuantity === '' || eachObj.ipQuantity === null) {
    //             count++;
    //         }
    //     });
    //     console.log(this.selectedpatient);
    //     if (count == 0) {
    //         let model: any = {};
    //         // model.vpPatientMrNumber = this.selectedpatient.visitPatientId.patientMrNo;
    //         model.vpAdmissionId = {admissionId: this.admissionId};
    //         model.vpPrescribedStaffId = {staffId: this.currentUser.staffId};
    //         model.vpStatus;
    //         this.cpoePrescriptionService.addRecordService(model)
    //             .then(resp => {
    //                 if (resp.success === '1') {
    //                     let id = resp.vpId;
    //                     let ObjArray: Array<any> = [];
    //                     for (let ob of this.prescriptionList) {
    //                         ob['itemFlag'] = true;
    //                         ob.ipVpId = {};
    //                         ob.ipVpId.vpId = id;
    //                         ob.createdByUserId = this.currentUser.staffId;
    //                         ob.createdBy = this.currentUser.staffUserId.userTitleId.titleName + ' ' + this.currentUser.staffUserId.userFirstname + ' ' + this.currentUser.staffUserId.userLastname;
    //                         if (ob.ipDfId.dfId == null || ob.ipDfId.dfId == '') {
    //                             delete ob.ipDfId;
    //                         }
    //                         if (ob.ipDiId.diId == null || ob.ipDiId.diId == '') {
    //                             delete ob.ipDiId;
    //                         }
    //                         if (ob.ipRouteId.routeId == null || ob.ipRouteId.routeId == '') {
    //                             delete ob.ipRouteId;
    //                         }
    //                         if (ob.ipInvItemId == undefined || ob.ipInvItemId.itemName == undefined || ob.ipInvItemId.itemName == null || ob.ipInvItemId.itemName == '') {
    //                             delete ob.ipInvItemId;
    //                         }
    //                         if (ob.itemGenericId == undefined || ob.itemGenericId.genericName == undefined || ob.itemGenericId.genericName == null || ob.itemGenericId.genericName == '') {
    //                             delete ob.itemGenericId;
    //                         }
    //                         console.log(ob);
    //                         delete ob.dfName;
    //                         ObjArray.push(ob);
    //                     }
    //                     this.temrVisitPrescriptionService.addDrugeList(ObjArray).then(resp2 => {
    //                         if (resp2.success === '1') {
    //                             this.timelineObj.timelineIsPrescription = true;
    //                             this.displayPrecp = false;
    //                             this.toastr.success(resp2.msg, 'Prescription Saved Succesfully !');
    //                             this.selectedAutoCompleteItem = [];
    //                             this.getSavedPrescription();
    //                         }
    //                     })
    //                     ;
    //                 }
    //             });
    //     }
    //     else {
    //         this.toastr.error('Please enter quantity or route', 'Incomplete Data! ');
    //         this.timelineObj.timelineIsPrescription = false;
    //     }
    // }
    updatePrescription(item: any) {
        this.selectedItemList.push(item.ipInvItemId);
        const control = <FormArray>this.AddForm.controls['itemPrescriptionList'];
        // control.push(this.editPrescription(item));
    }

    editPrescription(item: any) {
        // console.log('item edit');
        // console.log(item);
        // console.log('id i want');
        // console.log(item.ipDfId);
        // console.log(item.ipDfId.dfName)
        if (item.ipDfId != undefined) {
            this.selecteddfName = item.ipDfId.dfName;
            // console.log(this.selecteddfName);
        }
        //
        if (item.ipInvItemId != undefined) {
            this.fb.group({
                ipInvItemId: this.fb.group({'itemId': [item.ipInvItemId.itemId, Validators.required]})
            });
        }
        else {
            this.fb.group({
                ipInvItemId: this.fb.group({'itemId': [null, Validators.required]})
            });
        }
        if (item.ipDiId != undefined) {
            this.fb.group({
                ipDiId: this.fb.group({'diId': [item.ipDiId.diId, Validators.required]})
            });
        }
        else {
            this.fb.group({
                ipDiId: this.fb.group({'diId': [null, Validators.required]})
            });
        }
        if (item.ipDfId != undefined) {
            this.fb.group({
                ipDfId: this.fb.group({'dfId': [item.ipDfId.dfId, Validators.required]})
            });
        }
        else {
            this.fb.group({
                ipDfId: this.fb.group({'dfId': [null, Validators.required]})
            });
        }
        if (item.ipRouteId != undefined) {
            this.fb.group({
                ipRouteId: this.fb.group({'routeId': [item.ipRouteId.routeId, Validators.required]})
            });
        }
        else {
            this.fb.group({
                ipRouteId: this.fb.group({'routeId': [null, Validators.required]})
            });
        }
        // = {htId : this.selectedTemplate.ipDfId}
        return this.fb.group({
            itemPrescriptionList: [item.itemPrescriptionList],
            ipId: [item.ipId],
            ipQuantity: [item.ipQuantity],
            ipinstruction: [item.ipinstruction],
            ipDdId: [item.ipDdId, Validators.required]
            // ipInvItemId: this.fb.group({'itemId': [item.ipInvItemId.itemId, Validators.required]} ),
            // ipDiId: this.fb.group({'diId': [item.ipDiId.diId, Validators.required]}),
            // ipDfId: this.fb.group({'dfId': [item.ipDfId.dfId, Validators.required]}),
            // ipRouteId: this.fb.group({'routeId': [item.ipRouteId.routeId, Validators.required]})
        });
    }

    removePrescription(model: any, index: any) {
        console.log('on remove model print..', model);
        //  const control = <FormArray>this.AddForm.controls['itemPrescriptionList'];
        console.log('pre ', this.prescriptionList);
        if (this.timelineObj.timelineIsPrescription == false) {
            if (this.prescriptionList.length === 1) {
                this.prescriptionList = [];
            }
            else {
                this.prescriptionList.splice(index, 1);
                // this.selectedItemList = this.selectedItemList.filter(item => item.itemId != model.ipInvItemId.itemId);
                // this.selectedItemList = this.selectedItemList.filter(item => item.itemName != model.itemName);
                if (model.itemId == undefined) {
                    this.selectedItemList = this.selectedItemList.filter(item => item.itemName != model.itemName);
                } else {
                    this.selectedItemList = this.selectedItemList.filter(item => item.itemId != model.ipInvItemId.itemId);
                }
                console.log('this.prescriptionList..', this.prescriptionList);
                console.log('this.selectedItemList..', this.selectedItemList);
            }
        }
        else {
            this.toastr.error('Prescription Is Finalized..!');
        }
    }

    getPrimaryAssessmentDetails() {
        this.temrVisitHistoryService.getRecordByPatientId(this.timelineObj.timelinePatientId.patientId).then(resp => {
            if (resp.vhContent != '') {
                console.log('history');
                console.log(resp);
                this.temrVisitHistory = resp.record[0];
                this.selectedcheflist = [];
                this.temrVisitChiefComplaintService.getRecordServiceByTimelineId(this.timelineObj.timelineId).then(resp => {
                    console.log('cc saved');
                    console.log(resp);
                    if (resp.length > 0) {
                        this.timelineObj.timelineIsChiefComplaint = true;
                    } else {
                        this.timelineObj.timelineIsChiefComplaint = false;
                    }
                    for (let obj of resp) {
                        let tempobj: any = {};
                        // tempobj = obj.vccCcId;
                        // tempobj.vccId = obj.vccId;
                        this.selectedcheflist.push({unit: obj.vccCcUnit, chefno: obj.vccCcNo, chefobj: obj.vccCcId, chefOther: obj.vccCCOther});
                    }
                });
            }
        });
        this.getNonDrugAllergies();
    }

    onAllergyDeSelected(event: any) {
        // console.log(event);
        this.temrVisitNonDrugAllergyService.deleteRecordService(event.vndaId);
    }

    deleteall(allid: any) {
        let foundAllergy: any = {};
        for (let obj of this.nondrugAllergy) {
            if (obj.ndaId == allid || obj.ndaId == allid) {
                foundAllergy = obj;
            }
        }
        this.temrVisitNonDrugAllergyService.deleteRecordService(allid).then(resp => {
            if (resp.success === '1') {
                this.toastr.success(resp.msg, 'Success ! ');
                this.getNonDrugAllergies();
            }
        });
    }

    onAllergySelected(event: any, sensitivity: any, sensitivityName: any) {
        this.selectedalllist = this.selectedalllist.filter(item => item.ndaId != event.ndaId);
        event.vndaAsId = {};
        event.vndaAsId = {asId: sensitivity, asName: sensitivityName};
        this.selectedalllist.push(event);
        // console.log('non drug selected');
        // console.log(event);
        // console.log(this.selectedalllist);
        this.selectedNonDrugAllergied = {};
        let model: any = {};
        model.vndaNdaId = {ndaId: event.ndaId};
        model.vndaVisitId = {visitId: this.visit_id};
        model.vnTimelineId = {timelineId: this.timelineObj.timelineId};
        model.vndaAsId = {asId: sensitivity};
        model.createdByUserId = this.currentUserdetails.staffId;
        model.createdBy = this.currentUserdetails.staffUserId.userTitleId.titleName + ' ' + this.currentUserdetails.staffUserId.userFirstname + ' ' + this.currentUserdetails.staffUserId.userLastname;
        // console.log(model);
        this.temrVisitNonDrugAllergyService.addRecordService(model).then(resp => {
            // if((this.selectedItem != null && this.selectedItem != 'null' && this.selectedItem != '') ||
            //     (this.selectedNonDrugAllergied !=null && this.selectedNonDrugAllergied !='null'&& this.selectedNonDrugAllergied !='') ||
            //     (this.selectedItem !=null && this.selectedItem !='null'&& this.selectedItem !='' ))
            // {
            //     this.temrTimelineService.editBooleanRecordService(this.timelineObj.timelineId, 'allergies', true);
            // }
            if ((resp.success === '1') || (this.selectedItem != null && this.selectedItem != 'null' && this.selectedItem != '') ||
                (this.selectedNonDrugAllergied != null && this.selectedNonDrugAllergied != 'null' && this.selectedNonDrugAllergied != '') ||
                (this.selectedItem != null && this.selectedItem != 'null' && this.selectedItem != '')) {
                this.temrTimelineService.editBooleanRecordService(this.timelineObj.timelineId, 'allergies', true);
                this.toastr.success('Non-Drug Allegy Saved Successfully', 'Success ! ');
                // this.patientChartParentComponent.getContradictedNonDrugList(this.currentPatient.patientId);
                this.getNonDrugAllergies();
            }
            else {
                this.toastr.error(resp.msg, 'Failed ! ');
            }
        });
        // }
    }

    // DeleteAllergy(id: any) {
    //     this.temrVisitAllergyService.deleteRecordService(id).then(resp => {
    //         if (resp.success === '1') {
    //             this.toastr.success(resp.msg, 'Success ! ');
    //             this.loading = true;
    //             this.temrVisitAllergyService.getAllRecordByPatientIdService('1', '', this.currentPatient.patientId, '', '').then(
    //                 resp2 => {
    //                     this.allergyList = resp2.json().content;
    //                     this.config.currentPage = 1;
    //                     this.config.totalItems = resp2.json().totalElements;
    //                     this.loading = false;
    //                 }
    //             );
    //         }
    //         else {
    //             this.toastr.error(resp.msg, 'Failed ! ');
    //         }
    //     });
    // }
    //
    // getPage(page: number) {
    //     if (this.visitObj === '' || this.visitObj === undefined || this.visitObj === null) {
    //         this.mstVisitService.getRecordService(this.visit_id).then(resp => {
    //             setTimeout(() => {
    //                 this.currentPatient = resp.visitPatientId;
    //                 this.currentVisit = resp;
    //             }, 0);
    //         });
    //         this.loading = true;
    //         this.temrVisitAllergyService.getAllRecordByPatientIdService('1', '', this.timelineObj.timelinePatientId.patientId, '', '').then(
    //             resp2 => {
    //                 this.allergyList = resp2.json().content;
    //                 // console.log(resp2);
    //                 this.config.currentPage = page;
    //                 this.config.totalItems = resp2.json().totalElements;
    //                 this.loading = false;
    //                 // console.log(this.allergyList.length);
    //                 if (this.allergyList.length < 0) {
    //                     this.temrTimelineService.editBooleanRecordService(this.timelineObj.timelineId, 'allergies', false);
    //                 }
    //             }
    //         );
    //     }
    //     else {
    //         this.currentPatient = this.visitObj.visitPatientId;
    //         this.currentVisit = this.visitObj;
    //         this.temrVisitAllergyService.getAllRecordByPatientIdService('1', '', this.currentPatient.patientId, '', '').then(
    //             resp2 => {
    //                 this.allergyList = resp2.json().content;
    //                 // console.log(resp2);
    //                 this.config.currentPage = page;
    //                 this.config.totalItems = resp2.json().totalElements;
    //                 this.loading = false;
    //                 // console.log(this.allergyList.length);
    //                 if (this.allergyList.length < 0) {
    //                     this.temrTimelineService.editBooleanRecordService(this.timelineObj.timelineId, 'allergies', false);
    //                 }
    //             }
    //         );
    //     }
    // }
    getNonDrugAllergies() {
        this.selectedalllist = [];
        this.temrVisitNonDrugAllergyService.getByTimelineIdRecordService(this.timelineObj.timelineId).then(resp => {
            this.nondrugAllergy = resp;
            for (let obj of resp) {
                console.log('non drur alergy');
                console.log(obj);
                let tempobj: any = {};
                tempobj = obj.ndaId;
                if (obj.ndaId != undefined || obj.ndaId != null) {
                    this.selectedalllist.push({ndaId: obj.ndaId, ndaName: obj.ndaName, vndaAsId: {asId: obj.asId, asName: obj.asName}});
                }
                else {
                    this.selectedalllist.push({ndaId: obj.vndaNdaId.ndaId, ndaName: obj.vndaNdaId.ndaName, vndaAsId: null});
                }
            }
            // console.log(this.selectedalllist);
        });
    }

    prescriptionIndex: any;

    myPrespDialog(i) {
        this.prescriptionIndex = i;
        this.displayPrecp = true;
        // this.getPatientAllergy();
    }

    myDischargeSpInstructionGroup(i?: any) {
        this.dischargeSpInstructionGroupIndex = i;
        this.displaydischargeSpInstructionGroupIndex = true;
        // this.getPatientAllergy();
    }


    getPatientAllergy() {
        // this.temrVisitAllergyService.getAllRecordByPatientId(this.currentPatient.patientId).then(
        //     resp2 => {
        //         this.mstDrugAllergyList = resp2;
        //         console.log(resp2);
        //     }
        // );
        return;
    }

    searchIcdandDesc(event, colValue: any) {
        this.memrIcdCodeService.getDropDown(1, 10, event.query).then(resp => {
            this.icdCodeList = resp;
        });
    }

    diagnosisIndex: any;

    getDignosisList(i?: any) {

        let diagnosisContent = document.getElementById('diagnosisContent');
        this.selectedFormFieldList[this.diagnosisIndex].fieldControlValue = '';
        this.selectedFormFieldList[this.diagnosisIndex].fieldControlValue += diagnosisContent.innerHTML;

        console.log('Diagnosis : ', this.selectedFormFieldList);
        let page = 1;
        this.loading = true;
        this.temrVisitDiagnosisService.getAllRecordServicebyTimelineId(page, this.diagDonfig.itemsPerPage, this.timelineObj.timelineId, '', '')
            .then(resp2 => {
                console.log('digno  ', resp2);
                this.mstIcdCodeList = resp2;
                this.diagDonfig.currentPage = page;
                this.diagDonfig.totalItems = resp2.totalElements;
                this.diagPopupconfig.totalItems = resp2.totalElements;
                this.loading = false;
            });
        this.getDrugInstruction();
    }

    searchdosefreqdropdown(event) {
        this.mstDoseFrequencyService.getDropDown(1, 20, event.query).then(
            resp => {
                this.mstDoseFrequencyList = resp;
                // console.log('responsedosefreq');
                // console.log(resp);
            });
    }

    onChange(value: any, type: any, id: any) {
        // console.log('first and third');
        // console.log(value);
        switch (type) {
            case 'frequency':
                this.prescriptionList[id].ipDfId = {'dfId': value.dfId};
                this.prescriptionList[id].dfName = value.dfName;
                this.prescriptionList[id].ipQuantity = '';
                this.prescriptionList[id].ipDdId = '';
                this.currFreq = null;
                this.currFreq = value.dfName;
                // console.log(this.currFreq);
                break;
            case 'instruction':
                // console.log(value, id);
                this.prescriptionList[id].ipDiId = {'diId': value};
                break;
            case 'route':
                // console.log(value, id);
                this.prescriptionList[id].ipRouteId = {'routeId': value};
                break;
        }
    }

    onchanegQuantity(value: any) {
        if (value < 0 || value == '-') {
            this.duraton = '';
            this.toastr.error('Please Enter Correct Quantity !');
        }
    }

    onDurationChange(value: any, id: any, isliquid: any) {

        // const control = <FormArray>this.AddForm.controls['itemPrescriptionList'];
        // control.controls[id].get('ipQuantity').setValue('');
        this.prescriptionList[id].ipQuantity = '';
        // this.prescriptionList[id].ipDdId = '';
        if (value < 0 || value == '-') {
            this.duraton = '';
            this.toastr.error('Please Enter Correct Duration !');
        }
        else {
            if (isliquid) {
            }
            else {
                // console.log(this.prescriptionList);
                // console.log(this.prescriptionList[id]);
                let obj: any = {};
                this.frequencyCalculation(this.prescriptionList[id].dfName, id);
                if (!(value === '')) {
                    // console.log('totalQuantity---' + this.totalQuantity);
                    this.overAllQty = 0;
                    this.overAllQty = this.totalQuantity * parseFloat(value);
                    // console.log('overAllQty---' + this.overAllQty);
                    //  this.prescriptionList[id].vpDdId = value;
                    //  this.prescriptionList[id].vpQuantity = this.overAllQty;
                }
                this.prescriptionList[id].ipQuantity = this.overAllQty;
            }
        }
    }

    frequencyCalculation(value: any, id: any): number {
        let freq: any = {};
        let qtyArray: any[] = [];
        freq = value;
        qtyArray = freq.split('-');
        // console.log(qtyArray);
        this.totalQuantity = 0;
        for (const qty of qtyArray) {
            if (qty.includes('/')) {
                this.totalQuantity = (this.totalQuantity) + 1;
            }
            else {
                this.totalQuantity = (this.totalQuantity) + parseFloat(qty);
            }
        }
        // console.log(this.totalQuantity);
        return this.totalQuantity;
    }

    onDeleteRecord(id: any) {
        this.temrVisitDiagnosisService.deleteRecordService(id).then(resp => {
            if (resp.success === '1') {
                this.toastr.success(resp.msg, 'ICD Code Deleted ! ');
                this.ngOnInit();
                this.getDignosisListOnPopUp();
            }
            else {
                this.toastr.error(resp.msg, 'Failed to Add ICD Code ! ');
            }
        });
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary-new/discharge-summary-new.component.ts